import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Section from '../../../components/Section';

import styles from './FAQ.module.css';

export const FAQ: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (import.meta.env.SSR) {
      return;
    }
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'NAVIGATE') {
        navigate(event.data.path);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  if (import.meta.env.SSR) {
    return null;
  }

  return (
    <div className={styles.faq}>
      <Section>
        <iframe
          src={`https://jam-customer-care-hub.lovable.app/faq?homePageUrl=${window.location.origin}`}
          className={styles.iframe}
          title="FAQ"
        />
      </Section>
    </div>
  );
};
